import env from 'src/env/index';
import { Profile } from 'src/types';

const updateLocale = async (locale: string) => {
    try {
        const id_token = localStorage.getItem('id_token');
        const userProfile: Profile = JSON.parse(
            localStorage.getItem('profile') ?? '{}'
        );
        if (!id_token || !userProfile) {
            throw Error('No Id Token');
        }
        const body = {
            locale,
        };
        const data = await fetch(`${env.ssoV1Url}/api/profile/metadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${id_token.toString()}`,
            },
            body: JSON.stringify(body),
        });
        return data;
    } catch (e) {
        console.error('error ', e);
        return false;
    }
};

export default updateLocale;